import React, { useState } from 'react'
import ApiRequest from '../Common/restservice';
import { errorToast, successToast } from '../Common/showtoast';
import { useNavigate } from 'react-router-dom';

function Contactus() {
    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");
    const navigate = useNavigate();
    const update = async () => {
        if (!subject) {
            errorToast("Enter valid subject");
            return;
        } else if (!message) {
            errorToast("Enter valid message");
            return;
        }
        let res = await ApiRequest("contactus.asp", "POST", {
            subject,
            message
        }, { Authorization: localStorage.getItem("token") });
        if (res.status === "error") {
            errorToast(res.message);
            if (res.message === "Session Expired") {
                localStorage.clear();
                navigate("/login");
            }
            return;
        }
        successToast(res.message);
        setSubject("");
        setMessage("");
    }
    return (
        <section className="content">
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12 col-xm-12">
                    <div className="card overflow-hidden dash1-card border-0">
                        <form className="card-body ml-auto mr-auto col-lg-6" onSubmit={(e) => { e.preventDefault(); update(); }}>
                            <h5 className=" mt-3 mb-3" style={{ textAlign: "center" }}>Contact us</h5>
                            <div className="form-group row">
                                <div className="input-container">
                                    <input type="text" className="form-control col-lg-12" placeholder="Subject" aria-label="Old password" tabIndex="1" onChange={(e) => {
                                        setSubject(e.target.value)
                                    }} value={subject} />
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="input-container">
                                    <textarea className="form-control col-lg-12" placeholder="Enter your message here" aria-label="New password" tabIndex="1" onChange={(e) => {
                                        setMessage(e.target.value)
                                    }} value={message} />
                                </div>
                            </div>
                            <div className="d-flex justify-content-center">
                                <button className="col-lg-4 mb-5 btn btn-primary" type="submit">Send</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Contactus
